import React from 'react'
import { observer } from 'mobx-react'
import { decorationMobx, storeMobx, timePickMobx } from '@mobxStore'
import TimePickController from '@ctrls/timePickController'
import './index.scss'
import { cartMobx, restaurantConfig } from 'restaurant'

export interface IProps {
}

const TimePickBar: React.FC<IProps> = (props) => {
  const isBuyTogether = !!Config.buyTogetherId

  /** 堂食送餐制，不需要预约 */
  if (!timePickMobx.canBookingTime) {
    return null
  }
  // 拼单不展示
  if (restaurantConfig.codeType === 'brand' && isBuyTogether) return null
  if (!storeMobx.info.isMobileBookingOrder || !timePickMobx.canPick) return null

  const handlePreOrder = () => {
    TimePickController.handleAppointment()
  }

  return (
    <div className='time-pick-bar-container'>
      <button className='time-pick-bar-btn' type='button' onClick={handlePreOrder}>
        <i className='iconfont icon-time2x'></i>
        {
          timePickMobx.selectedInfo?.pickTime ? (
            <span>
              {timePickMobx.getTimeText('default')}
            </span>
          ) : <span>{i18n.t('newCart.booking_pickup')}</span>
        }
      </button>
    </div>
  )
}

export default observer(TimePickBar)
